import React, { useEffect, useState } from "react"
import { isStreamingKit } from "../../common/utils"
import { PrimaryButton } from "../shared/button"
import { Input } from "../shared/input"
import { Error } from './styles'

const PreviewForm = ({ name, email, onChangeEmail, onChangeName, onJoin, enableJoin }) => {
  const [nameError, setNameError] = useState(null)
  const [emailError, setEmailError] = useState(null)

  useEffect(() => {
    if (typeof window === "undefined") return
    const params = new URLSearchParams(window.location.search)
    onChangeEmail(params.get("email"))
  }, [onChangeEmail])

  const validateName = (value) => {
    if (!value) {
      setNameError("Name is required")
      return false
    }

    setNameError("")
    return true
  }

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!value) {
      setEmailError("Email is required")
      return false
    }
    if (!emailRegex.test(value)) {
      setEmailError("Invalid email format")
      return false
    }
    setEmailError("")
    return true
  }

  const formSubmit = (e) => {
    e.preventDefault()

    const isNameValid = validateName()
    const isEmailValid = validateEmail()

    if (isNameValid && isEmailValid) {
      // No validation errors, proceed with form submission
      onJoin()
    }
  }

  return (
    <form onSubmit={formSubmit}>
      <Input
        required
        id="name"
        style={{ width: "100%" }}
        value={name}
        onChange={(e) => {
          onChangeName(e.target.value)
          validateName(e.target.value)
        }}
        placeholder="Enter your name"
        type="text"
        autoComplete="name"
      />
      <Input
        required
        id="email"
        style={{ width: "100%" }}
        value={email}
        onChange={(e) => {
          onChangeEmail(e.target.value)
          validateEmail(e.target.value)
        }}
        placeholder="Enter your email"
        type="email"
        autoComplete="email"
      />
      <PrimaryButton
        type="submit"
        disabled={!name || !email || !enableJoin || nameError || emailError}
        onClick={onJoin}
        width="100%"
      >
        {isStreamingKit() ? "Join Studio" : "Join Webinar"}
      </PrimaryButton>

      {nameError && emailError && <Error>Please check your name and email </Error>}

      {nameError && !emailError && <Error>{nameError}</Error>}

      {emailError && !nameError && <Error>{emailError}</Error>}
    </form>
  )
}

export default PreviewForm
